import React, { Dispatch, SetStateAction, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

import CloseIcon from 'app/components/Icons/CloseIcon';
import CustomInput from 'app/components/CustomInput';
import { useForm } from 'react-hook-form';
import { CreatePaymentRequestBody } from 'app/utils/services/types/salary.type';
import { useAddPerson } from 'app/utils/services/salaryServices';

import { closeBtn, dialogActions, dialogTitle, paperProps, title } from './EmployeeModal.sx';
import SuccessModal from 'app/pages/SalaryPage/SuccessModal';
interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  headerText: string;
  iban?: string;
  setIban?: Dispatch<SetStateAction<string>>;
  amount?: string;
  setAmount?: Dispatch<SetStateAction<string>>;
  refetchSalaryData?: () => void;
}

const EmployeeModal = (props: Props) => {
  const {
    register,
    handleSubmit,
    setError,
    reset,
    formState: { errors },
  } = useForm();
  const { open, close } = props;
  const [successModal, setSuccessModal] = useState(false);

  const mutate = useAddPerson();

  const onSubmit = (data: CreatePaymentRequestBody) => {
    mutate.mutate(data, {
      onSuccess: () => {
        setSuccessModal(true);
        reset();
      },
      onError: (errorResponse: any) => {
        if (errorResponse?.response?.data?.error?.fields?.iban) {
          setError('iban', { message: errorResponse?.response?.data?.error?.fields?.iban, type: 'validate' });

          return;
        }
        setError('amount', { message: 'Məbləğ duzgun deyil', type: 'validate' });
      },
    });
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: paperProps,
        }}
        onClose={() => {
          close(false);
          reset();
        }}
      >
        <form>
          <DialogTitle sx={{ ...dialogTitle, mb: '28px' }}>
            <Typography sx={title}>Əməkdaş əlavə et</Typography>
            <Button
              color={'tertiary'}
              onClick={() => {
                close(false);
                reset();
              }}
              sx={closeBtn}
            >
              <CloseIcon />
            </Button>
          </DialogTitle>
          <DialogContent sx={{ display: 'flex', flexDirection: 'column', pl: '40px', gap: '16px' }}>
            <CustomInput
              rest={{
                ...register('iban', {
                  required: 'Hesab nömrəsi / IBAN mütləqdir',
                }),
              }}
              title={'Hesab nömrəsi / IBAN'}
              placeholder={'Hesab nömrəsi / IBAN'}
              isValid={!!errors.iban}
              errorText={String(errors.iban?.message)}
            />
            <CustomInput
              rest={{
                ...register('amount', {
                  required: 'Məbləğ mütləqdir',
                }),
              }}
              title={'Məbləğ'}
              placeholder={'Məbləğ'}
              isValid={!!errors.amount}
              errorText={String(errors.amount?.message)}
            />
          </DialogContent>
          <DialogActions sx={dialogActions}>
            <Button onClick={handleSubmit(onSubmit)}>Yadda saxla</Button>
            <Button
              color={'secondary'}
              sx={{ ml: '0 !important' }}
              onClick={() => {
                close(false);
                reset();
              }}
            >
              Ləğv et
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <SuccessModal
        open={successModal}
        close={setSuccessModal}
        closeAction={() => {
          close(false);
          props.refetchSalaryData();
        }}
        successText="Əməkdaş siyahıya uğurla əlavə edildi."
      />
    </>
  );
};

export default EmployeeModal;
